import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';
import {
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

export const MORE_TEXT_LINE_HEIGHT = 24;

const styles = StyleSheet.create({
    moreContainer: {
        marginBottom: 24,
        marginHorizontal: widthPercentageToDP(16, 44, 72),
        width: isTablet ? 436 : undefined,
    },
    moreTextView: {
        width: 'auto',
        textAlign: isTabletOrWeb ? 'left' : 'center',
        fontFamily: Fonts.main.regular,
        fontSize: 16,
        color: lightGrey(),
        lineHeight: Platform.select({
            android: MORE_TEXT_LINE_HEIGHT + 10,
            default: MORE_TEXT_LINE_HEIGHT,
        }),
    },
    moreTextButton: {
        alignSelf: 'flex-end',
        color: COLOR.WHITE,
        fontFamily: Fonts.main.bold,
        fontSize: 16,
        lineHeight: 24,
        textTransform: 'uppercase',
    },
    webContainer: {
        maxWidth: widthPercentageToDP(515),
        height: 2 * MORE_TEXT_LINE_HEIGHT,
        color: lightGrey(),
        fontSize: 16,
        lineHeight: MORE_TEXT_LINE_HEIGHT,
        fontFamily: Fonts.main.regular,
        textAlign: 'left',
    },
    webMoreButton: {
        fontFamily: Fonts.main.bold,
        textTransform: 'uppercase',
        color: COLOR.WHITE,
        // @ts-ignore
        cursor: 'pointer',
    },
});

export default styles;
